import { getRequestDefaultOptions } from '../request.utils';
import { RequestOptions } from '@nirvana/shared/websocket-client';

export class MicroserviceRequest {
  public static async makeRequest<RequestType, ResponseType>(
    clientName: string,
    methodName: string,
    requestData: RequestType,
    requestOptions?: RequestOptions
  ): Promise<ResponseType> {
    if (!globalThis.nirvana.microservice || !globalThis.nirvana.microservice.clients) {
      throw new Error('Global Nirvana microservice clients not defined');
    }
    if (!Reflect.has(globalThis.nirvana.microservice.clients, clientName)) {
      throw new Error(`Client ${clientName} not found!`);
    }
    const client = Reflect.get(globalThis.nirvana.microservice.clients, clientName);
    // @ts-ignore: TS2576
    const clientInstance = await globalThis.nirvana.microservice.clients.Manager.getClient(client);

    if (!Reflect.has(clientInstance, methodName) || !(Reflect.get(clientInstance, methodName) instanceof Function)) {
      throw new Error(`Method ${methodName} not found on microservice ${clientName}`);
    }
    const options = requestOptions ? requestOptions : getRequestDefaultOptions();
    try {
      const response = await clientInstance[methodName](requestData, options);

      if (response.toPromise) {
        return response.toPromise() as Promise<ResponseType>;
      }

      return response as Promise<ResponseType>;
    } catch (exception) {
      console.error(exception);
      throw exception;
    }
  }
}
